import { useContext } from 'react';
import { createSelector } from 'reselect';
import { FeedStateContext, TradingblockWebsocketState } from './FeedState';

const getFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.status,
  status => status
);
export const useFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getFeedStatus(state);
};

const getWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.webSocketCloseReason,
  closeReason => closeReason
);
export const useWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getWebSocketCloseReason(state);
};

const getFeedQuoteQueue = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.quoteQueue,
  quotes => quotes
);
export const useFeedQuoteQueue = () => {
  const state = useContext(FeedStateContext);
  return getFeedQuoteQueue(state);
};

const getFeedSpreadQueue = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.spreadQueue,
  spreads => spreads
);
export const useFeedSpreadQueue = () => {
  const state = useContext(FeedStateContext);
  return getFeedSpreadQueue(state);
};

const getLatestCashieringUpdateData = createSelector(
  (state: TradingblockWebsocketState) => state.cashieringUpdates.latestUpdateData,
  latestCashieringUpdateData => latestCashieringUpdateData
);

export const useLatestCashieringUpdateFeedData = () => {
  const state = useContext(FeedStateContext);

  return getLatestCashieringUpdateData(state);
};

const getNewsFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsStatus,
  status => status
);
export const useNewsFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getNewsFeedStatus(state);
};

const getNewsWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsWebSocketCloseReason,
  closeReason => closeReason
);

export const useNewsWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getNewsWebSocketCloseReason(state);
};

const getOrderStatusFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.orderStatus,
  status => status
);
export const useOrderStatusFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getOrderStatusFeedStatus(state);
};

const getOrderStatusWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsWebSocketCloseReason,
  closeReason => closeReason
);
export const useOrderStatusWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getOrderStatusWebSocketCloseReason(state);
};

const getExpiringTokensFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.expiringTokensFeedStatus,
  status => status
);
export const useExpiringTokensFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getExpiringTokensFeedStatus(state);
};

const getExpiringTokensWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.expiringTokensWebSocketCloseReason,
  closeReason => closeReason
);
export const useExpiringTokensWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getExpiringTokensWebSocketCloseReason(state);
};

const getCashieringFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.cashieringStatus,
  status => status
);
export const useCashieringFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getCashieringFeedStatus(state);
};

const getCashieringWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.cashieringWebSocketCloseReason,
  closeReason => closeReason
);
export const useCashieringWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getCashieringWebSocketCloseReason(state);
};

const getNewsSubcriptions = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.newsSubscriptions,
  newsSubscriptions => newsSubscriptions
);
export const useNewsSubcriptions = () => {
  const state = useContext(FeedStateContext);
  return getNewsSubcriptions(state);
};

const getLoginCountFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.loginCountFeedStatus,
  loginCountFeedStatus => loginCountFeedStatus
);
export const useLoginCountFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getLoginCountFeedStatus(state);
};

const getLoginCountWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.loginCountWebSocketCloseReason,
  closeReason => closeReason
);
export const useLoginCountWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getLoginCountWebSocketCloseReason(state);
};

const getQuotesFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.quotesFeedStatus,
  quotesFeedStatus => quotesFeedStatus
);
export const useQuotesFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getQuotesFeedStatus(state);
};

const getQuotesWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.quotesWebSocketCloseReason,
  closeReason => closeReason
);
export const useQuotesWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getQuotesWebSocketCloseReason(state);
};


const getSpreadsFeedStatus = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.spreadsFeedStatus,
  spreadsFeedStatus => spreadsFeedStatus
);
export const useSpreadsFeedStatus = () => {
  const state = useContext(FeedStateContext);
  return getSpreadsFeedStatus(state);
};

const getSpreadsWebSocketCloseReason = createSelector(
  // inputSelectors
  (state: TradingblockWebsocketState) => state.spreadsWebSocketCloseReason,
  closeReason => closeReason
);
export const useSpreadsWebSocketCloseReason = () => {
  const state = useContext(FeedStateContext);
  return getSpreadsWebSocketCloseReason(state);
};